module.exports = __webpack_public_path__ + "static/media/mv.cc120b55.svg";